import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TrackedLink } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { InsightCardContext } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardContext";
import { InsightCardProductImage } from "@faire/retailer-visitor-shared/features/InsightsFeed/InsightCardProductImage";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import { useProductTileViewImpression } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileViewImpression";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import productPage from "@faire/web-api--source/routes/product/productToken";
import React, { useContext } from "react";
import styled from "styled-components";
export var InsightCardProduct = function(param) {
    var brandToken = param.brandToken, product = param.product, asCarouselTile = param.asCarouselTile, shouldShowVerticalImagery = param.shouldShowVerticalImagery, isCompact = param.isCompact;
    var _product_product_token;
    var productToken = (_product_product_token = product.product_token) !== null && _product_product_token !== void 0 ? _product_product_token : "";
    var impressionId = product.impression_id;
    var onProductClick = useContext(InsightCardContext).onProductClick;
    var recordProductTileClickEvent = useProductTileClickImpressions({
        token: productToken,
        bestImage: product.image,
        impressionId: impressionId
    }, brandToken, true).recordProductTileClickEvent;
    var _useProductTileViewImpression = useProductTileViewImpression({
        productToken: productToken,
        impressionId: impressionId,
        turnOffTracking: false
    }), trackProductTileViewRef = _useProductTileViewImpression.ref, restTrackProductTileViewProps = _object_without_properties(_useProductTileViewImpression, [
        "ref"
    ]);
    var internalOnProductClick = useEffectEvent(function() {
        recordProductTileClickEvent();
        onProductClick === null || onProductClick === void 0 ? void 0 : onProductClick(productToken);
    });
    var _product_product_token1, _product_product_token2;
    return /*#__PURE__*/ _jsxs(ProductLink, _object_spread_props(_object_spread({
        innerRef: trackProductTileViewRef
    }, restTrackProductTileViewProps), {
        token: (_product_product_token1 = product.product_token) !== null && _product_product_token1 !== void 0 ? _product_product_token1 : "",
        to: productPage((_product_product_token2 = product.product_token) !== null && _product_product_token2 !== void 0 ? _product_product_token2 : ""),
        onClick: internalOnProductClick,
        "data-test-id": "insightTile-product-link-".concat(product.product_token),
        children: [
            /*#__PURE__*/ _jsx(InsightCardProductImage, {
                image: product.image,
                asCarouselTile: asCarouselTile,
                shouldShowVerticalImagery: shouldShowVerticalImagery,
                isCompact: isCompact
            }),
            /*#__PURE__*/ _jsx(TransparencyOverlay, {})
        ]
    }));
};
var ProductLink = styled(TrackedLink).withConfig({
    componentId: "sc-bd7365e4-0"
})([
    "position:relative;flex:1;margin:2px;&:focus-visible{outline:2px solid -webkit-focus-ring-color;}"
]);
